import Vue from "vue";
import VueMeta from "vue-meta";

import App from "./App.vue";
import router from "./router";
import infiniteScroll from "vue-infinite-scroll";
import store from "./store";
import Toasted from "vue-toasted";
import VueClipboard from "vue-clipboard2";
import httpService from "@/api-client/interceptors";
import "./utils/toasted";

Vue.config.productionTip = false;

Vue.use(infiniteScroll);

Vue.use(VueClipboard);
Vue.use(VueMeta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true
});
httpService.setupInterceptors(store, router);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

if (process.env.NODE_ENV !== "production" && window !== "undefined") {
  window.VUEX_STORE = store;
  window.Vue = Vue;
}
